export const RESPONSE_STATUS = {
    NOT_FOUND: 404,
    UNAUTHORIZED: 401
};
